export default "__VITE_ASSET__2TVtSjHg__"